// Return null for ordinary text so the textarea keeps its native Enter behavior.
export function continueList(value, start, end) {
  const lineStart = value.lastIndexOf('\n', start - 1) + 1;
  const beforeCaret = value.slice(lineStart, start);
  const match = beforeCaret.match(/^([ \t]*)([•*-]|\d+[.)])([ \t]+)(.*)$/);
  if (!match) return null;
  const [, indent, marker, spacing, content] = match;
  const lineEnd = value.indexOf('\n', end);
  const remainder = value.slice(end, lineEnd === -1 ? value.length : lineEnd);
  // Enter on an empty list item exits the list instead of adding another marker.
  if (!content.trim() && !remainder.trim()) {
    return { value: value.slice(0, lineStart) + value.slice(end), caret: lineStart };
  }
  const nextMarker = /^\d/.test(marker)
    ? `${Number.parseInt(marker, 10) + 1}${marker.slice(-1)}`
    : marker;
  const insertion = `\n${indent}${nextMarker}${spacing}`;
  return {
    value: value.slice(0, start) + insertion + value.slice(end),
    caret: start + insertion.length,
  };
}
